import { render, staticRenderFns } from "./shopCheckPaymentFailed.vue?vue&type=template&id=35edfbea"
import script from "./shopCheckPaymentFailed.vue?vue&type=script&lang=js"
export * from "./shopCheckPaymentFailed.vue?vue&type=script&lang=js"
import style0 from "./shopCheckPaymentFailed.vue?vue&type=style&index=0&id=35edfbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports